export const GET_PROJECT_CREATOR_INVITES_QUERY = `
    query Invites ( $project_id: Int! ) {
        invites(project_id: $project_id) {
            has_email
            user_email
            deliverables
            accepted
            invited
            link
            status
            creator {
                id
                account_creator {
                    id
                    first_name
                    last_name
                    username
                    avatar
                    email
                }
            }
        }
    }
`;
